import React from 'react'
import { Button, Input, Form} from "antd";
import { updateEmailApi } from '../../services/apiService'
import { showApiSuccess } from "../utilities";

class ChangeEmailForm extends React.Component {
  constructor(props) {
    super(props)
    this.existingEmail = window.sessionStorage.getItem("email") 
    //console.log("constructor")
  }

  handleSubmit = e => {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        //console.log('Received values of form: ', values);
        let data = {
          UserName: window.sessionStorage.getItem("UserName"),
          Email: this.existingEmail,
          NewEmail: values.email
        }
        updateEmailApi(data)
          .then((res) => {
            //console.log("res: " + res)
            if (res) {
              showApiSuccess("email updated successfully")
              window.sessionStorage.setItem("email", values.email) 
            }
          })
      }
    })
  }

  render() {
    const { getFieldDecorator } = this.props.form;
    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 4 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
    }
    const tailFormItemLayout = {
      wrapperCol: {
        xs: {
          span: 24,
          offset: 0,
        },
        sm: {
          span: 16,
          offset: 4,
        },
      },
    };

    //let existingEmail = window.sessionStorage.getItem("email") 
    //console.log("existing email:" + existingEmail)
    return (
      <div>

        <div className="panel" style={{ padding: 10 }}>
          <h4>Update Email</h4>
        </div>
        <Form {...formItemLayout} onSubmit={this.handleSubmit}>
          <Form.Item label="E-mail">
            {getFieldDecorator('email', {
              initialValue: this.existingEmail,
              rules: [
                {
                  type: 'email',
                  message: 'The input is not valid E-mail!',
                },
                {
                  required: true,
                  message: 'Please input your E-mail!',
                },
              ],
            })(<Input />)}
          </Form.Item>
          <Form.Item {...tailFormItemLayout}>
            <Button type="primary" htmlType="submit">Update</Button>
          </Form.Item>
        </Form>
      </div>
    )
  }
}

const WrappedChangeEmailForm = Form.create({ name: 'changeemail' })(ChangeEmailForm);
export default WrappedChangeEmailForm;